import classNames from 'classnames';
import dayjs from 'dayjs';
import { ConversationChunk } from '../../../../matrix/hooks/useConversations';
import styles from '../MatrixConversation.module.scss';

export type MatrixConversationItemProps = {
  chunk: ConversationChunk;
};
export const MatrixConversationItem = ({ chunk }: MatrixConversationItemProps) => {
  return (
    <div className={classNames(styles.chunk, chunk.isIncoming ? styles.incoming : styles.outgoing)}>
      <div className={styles.initials} style={{ color: chunk.color }}>
        {chunk.initials}
      </div>
      <div className={styles.messages}>
        {chunk.messages.map((message, index) => {
          return (
            <div key={index} className={styles.message}>
              <div className={styles.content}>{message.content}</div>
              <div className={styles.date}>{dayjs(message.date).fromNow()}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
